import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "rounded-2xl bg-white p-4 lg:p-6 flex flex-col gap-y-4 w-full" }
const _hoisted_2 = { class: "text-base font-bold" }
const _hoisted_3 = { class: "border border-gray-lp-400 rounded-xl flex items-center gap-x-3 px-4 py-3 my-1.5" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "font-bold text-black-lp-300 text-xl" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm font-medium"
}
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "text-black-lp-300 text-sm xxl:text-16px" }
const _hoisted_9 = { class: "font-semibold text-14px xxl:text-16px" }
const _hoisted_10 = {
  key: 0,
  class: "text-sm text-red-lp-100 font-semibold bg-red-lp-1300 rounded-md px-5 py-2.5 text-center flex items-center gap-x-3"
}
const _hoisted_11 = { class: "rounded-full bg-white p-2" }
const _hoisted_12 = { class: "rounded-full bg-red-lp-100 flex items-center justify-center p-1" }
const _hoisted_13 = { class: "pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_OtpDisclaimer = _resolveComponent("OtpDisclaimer")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_ModalOtp = _resolveComponent("ModalOtp")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("codIncome.withdrawal.sidebarTitle")), 1),
      (!_ctx.isLoadingBeneficiary)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('codIncome.withdrawal.destinationAccount'),
              class: "w-full",
              fontStyleLabel: "text-black-lp-300 text-sm font-normal"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_3, [
                  (_ctx.hasBeneficiary)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: _ctx.beneficiary.bankAccountLogo,
                        alt: _ctx.beneficiary.bankName,
                        class: "w-8 h-8 object-contain flex-shrink-0"
                      }, null, 8, ["src", "alt"]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_4, [
                    _createVNode("p", _hoisted_5, _toDisplayString(_ctx.hasBeneficiary ? _ctx.beneficiary.bankAccountNumber : "-"), 1),
                    (_ctx.hasBeneficiary)
                      ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.beneficiary.bankAccountName), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode("div", _hoisted_7, [
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("codIncome.withdrawal.amountSummaryLabel")), 1),
              _createVNode("p", _hoisted_9, _toDisplayString(_ctx.formatPrice(_ctx.amount)), 1)
            ]),
            _createVNode(_component_OtpDisclaimer, { show: _ctx.isRolloutOn }, null, 8, ["show"]),
            (_ctx.errorMessageOtp)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_Icons, {
                        name: "close",
                        class: "w-3 h-3 text-white"
                      })
                    ])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.errorMessageOtp), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isVisibleRequest)
              ? (_openBlock(), _createBlock(_component_button_fill, {
                  key: 1,
                  custom: "w-full bg-red-lp-200",
                  title: _ctx.$t('codIncome.withdrawal.withdrawButton'),
                  iconLeft: "withdraw-gray",
                  onClick: _ctx.onSubmitWithdraw,
                  isDisabled: _ctx.isDisabled
                }, null, 8, ["title", "onClick", "isDisabled"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_skeleton, {
                width: "8rem",
                class: "my-2"
              }),
              _createVNode(_component_skeleton, { height: "4rem" })
            ]),
            _createVNode("div", null, [
              _createVNode(_component_skeleton, {
                width: "8rem",
                class: "my-2"
              }),
              _createVNode(_component_skeleton, { height: "2rem" })
            ])
          ], 64))
    ]),
    _createVNode(_component_ModalOtp, {
      modelValue: _ctx.isModalOtp,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => (_ctx.isModalOtp = $event)),
        _ctx.onUpdateOpenOtp
      ],
      email: _ctx.emailUser,
      password: _ctx.password,
      action: _ctx.actionRequestOtp,
      onVerify: _ctx.onVerify,
      isWithdraw: "",
      isWithContacts: ""
    }, null, 8, ["modelValue", "onUpdate:modelValue", "email", "password", "action", "onVerify"])
  ], 64))
}